import pushid from 'pushid';
import router from '@/router/router';
import { slugify, getEnvironment } from '@/helpers/utils';
import cloneDeep from 'clone-deep';

export const Page = {
    state: {
        pages: [
            {
                type: 'home',
                name: 'Startseite',
                restrictions: {
                    starter: true,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: false,
                    hidable: false
                }
            },
            {
                type: 'imprint',
                name: 'Impressum',
                restrictions: {
                    starter: true,
                    basic: true,
                    menus: ['footer'],
                    onceOverall: true,
                    deletable: false,
                    hidable: true
                }
            },
            {
                type: 'privacy',
                name: 'Datenschutz',
                restrictions: {
                    starter: true,
                    basic: true,
                    menus: ['footer'],
                    onceOverall: true,
                    deletable: false,
                    hidable: true
                }
            },
            {
                type: 'sectors',
                name: 'Leistungen',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'jobs',
                name: 'Stellenanzeigen',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'about',
                name: 'Über uns',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'team',
                name: 'Team',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'references',
                name: 'Projekte',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'contact',
                name: 'Kontakt',
                restrictions: {
                    starter: false,
                    basic: true,
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            },
            {
                type: 'free',
                name: 'Frei',
                restrictions: {
                    starter: false,
                    basic: getEnvironment() === 'development',
                    menus: ['header'],
                    onceOverall: true,
                    deletable: true,
                    hidable: true
                }
            }
        ]
    },
    mutations: {},
    getters: {
        getAllPageTypes(state) {
            let pages = {};
            Object.values(state.pages).forEach((pages__value) => {
                pages[pages__value.type] = pages__value.name;
            });
            return pages;
        },
        getBasicOnlyPageTypes(state) {
            let pages = {};
            Object.values(state.pages).forEach((pages__value) => {
                if (
                    pages__value.restrictions.starter === false &&
                    pages__value.restrictions.basic === true
                ) {
                    pages[pages__value.type] = pages__value.name;
                }
            });
            return pages;
        },
        getPossiblePagesToCreate(state, getters) {
            return (menu) => {
                let pages = {},
                    existing = getters.getPages,
                    hasPackageBasic = getters.hasPackageBasic;
                Object.values(state.pages).forEach((pages__value) => {
                    let allowed = true;
                    if (
                        (pages__value.restrictions.starter === false &&
                            !hasPackageBasic === true) ||
                        (pages__value.restrictions.basic === false && hasPackageBasic === true)
                    ) {
                        allowed = false;
                    }
                    if (!pages__value.restrictions.menus.includes(menu)) {
                        allowed = false;
                    }
                    if (existing !== null) {
                        Object.values(existing).forEach((existing__value) => {
                            if (
                                pages__value.restrictions.onceOverall === true &&
                                existing__value.type === pages__value.type
                            ) {
                                allowed = false;
                            }
                        });
                    }
                    if (allowed === true) {
                        pages[pages__value.type] = pages__value.name;
                    }
                });
                return pages;
            };
        },
        getActivePageRoute(state, getters, rootState) {
            if (rootState.route.params.page) {
                return rootState.route.params.page;
            }
            return null;
        },
        getActivePage(state, getters, rootState) {
            if (rootState.tecpage && rootState.tecpage.user && rootState.tecpage.user.pages) {
                let page = Object.values(rootState.tecpage.user.pages).find(
                    (i) =>
                        ((rootState.route.params.page === undefined ||
                            rootState.route.params.page === null) &&
                            i.slug === '/') ||
                        i.slug === '/' + rootState.route.params.page
                );
                if (page !== undefined) {
                    return page;
                }
            }
            return null;
        },
        getActivePageId(state, getters) {
            let page = getters.getActivePage;
            if (page !== null) {
                return page.id;
            }
            return null;
        },
        getActivePageType(state, getters) {
            let page = getters.getActivePage;
            if (page !== null) {
                return page.type;
            }
            return null;
        },
        getActivePageName(state, getters) {
            let page = getters.getActivePage;
            if (page !== null) {
                return page.name;
            }
            return null;
        },
        getActivePageMetaTitle(state, getters) {
            let page = getters.getActivePage,
                title = '';
            title += getters.getProp('deha.user.firma1');
            title +=
                page === null || !('title' in page) || page.title === null
                    ? ''
                    : ' | ' + page.title;
            return title;
        },
        getActivePageMetaDescription(state, getters) {
            let page = getters.getActivePage,
                description = '';
            description +=
                page === null || !('description' in page) || page.description === null
                    ? ''
                    : page.description;
            return description;
        },
        getPageFromSlug(state, getters, rootState) {
            return (slug) => {
                if (rootState.tecpage.user && rootState.tecpage.user.pages) {
                    let page = Object.values(rootState.tecpage.user.pages).find(
                        (i) => i.slug === slug
                    );
                    if (page !== undefined) {
                        return page;
                    }
                }
                return null;
            };
        },
        getPageUrlFromType(state, getters, rootState) {
            return (type) => {
                if (rootState.tecpage.user && rootState.tecpage.user.pages) {
                    let page = Object.values(rootState.tecpage.user.pages).find(
                        (i) => i.type === type
                    );
                    if (page !== undefined) {
                        return (
                            '/' + router.currentRoute.name + (page.slug !== '/' ? page.slug : '')
                        );
                    }
                }
                return null;
            };
        },
        getPageDataByType(state) {
            return (type) => {
                return cloneDeep(state.pages).find((i) => i.type === type);
            };
        },
        getPageFromId(state, getters) {
            return (id) => {
                if (id === undefined || id === null || id === '') {
                    return undefined;
                }
                return getters.getProp('tecpage.user.pages.' + id);
            };
        },
        getPageTypeFromId(state, getters) {
            return (id) => {
                let page = getters.getPageFromId(id);
                if (page === undefined || page === null) {
                    return null;
                }
                return page.type;
            };
        },
        getPageUrlFromId(state, getters) {
            return (id) => {
                let page = getters.getPageFromId(id);
                if (page === undefined || page === null) {
                    return null;
                }
                return '/' + router.currentRoute.name + (page.slug !== '/' ? page.slug : '');
            };
        },
        getPageUrlFromSlug(state, getters) {
            return (slug) => {
                let page = getters.getPageFromSlug(slug);
                if (page === undefined || page === null) {
                    return null;
                }
                return '/' + router.currentRoute.name + (page.slug !== '/' ? page.slug : '');
            };
        },
        getPageIdFromSlug(state, getters) {
            return (slug) => {
                let page = getters.getPageFromSlug(slug);
                if (page !== null) {
                    return page.id;
                }
                return null;
            };
        },
        getPageFromType(state, getters, rootState) {
            return (type) => {
                if (rootState.tecpage.user && rootState.tecpage.user.pages) {
                    let page = Object.values(rootState.tecpage.user.pages).find(
                        (i) => i.type === type
                    );
                    if (page !== undefined) {
                        return page;
                    }
                }
                return null;
            };
        },
        getPageIdFromType(state, getters) {
            return (type) => {
                let page = getters.getPageFromType(type);
                if (page !== null) {
                    return page.id;
                }
                return null;
            };
        },
        getPages(state, getters, rootState) {
            if (rootState.tecpage.user && rootState.tecpage.user.pages) {
                return rootState.tecpage.user.pages;
            }
            return null;
        },
        getPagesFromMenuId(state, getters) {
            return (menu_id) => {
                let pages = getters.getPages;
                if (pages === null) {
                    return null;
                }
                return Object.values(pages).filter((i) => i.menu_id === menu_id);
            };
        },
        generateSlug(state, getters) {
            return (name) => {
                if (name === undefined || name === null || name === '') {
                    return '/';
                }
                let slug_orig = '/' + slugify(name),
                    slug = slug_orig,
                    slug_counter = 1;
                while (getters.slugAlreadyExists(slug)) {
                    slug_counter++;
                    slug = slug_orig + '-' + slug_counter;
                }
                return slug;
            };
        },
        slugAlreadyExists(state, getters, rootState) {
            return (slug) => {
                if (!rootState.tecpage.user && !rootState.tecpage.user.pages) {
                    return false;
                }
                return (
                    Object.values(rootState.tecpage.user.pages).find((i) => i.slug === slug) !==
                    undefined
                );
            };
        },
        isPageDeletable(state, getters) {
            return (id) => {
                let item = getters.getProp('tecpage.user.pages.' + id);
                if (item === undefined) {
                    return false;
                }
                let data = getters.getPageDataByType(item.type);
                if (data === undefined) {
                    return false;
                }
                return data.restrictions.deletable;
            };
        },
        isPageHidable(state, getters) {
            return (id) => {
                let item = getters.getProp('tecpage.user.pages.' + id);
                if (item === undefined) {
                    return false;
                }
                let data = getters.getPageDataByType(item.type);
                if (data === undefined) {
                    return false;
                }
                return data.restrictions.hidable;
            };
        }
    },
    actions: {
        async redirectToHomeIfPageDoesNotExist(context) {
            if (
                context.rootState.route.params.page !== undefined &&
                context.rootState.route.params.page !== null &&
                context.getters.getActivePageId === null
            ) {
                await new Promise((resolve) => {
                    router.push(
                        {
                            name: 'editor',
                            query: context.rootState.route.query
                        },
                        () => {
                            resolve();
                        }
                    );
                });
            }
        },
        async createPage(context, payload) {
            let menu_id = null;
            if ('menu_id' in payload) {
                menu_id = payload.menu_id;
            }
            if ('menu' in payload) {
                menu_id = context.getters.getMenuIdFromType(payload.menu);
            }
            let name = null;
            if ('name' in payload) {
                name = payload.name;
            } else {
                name = context.getters.getPageDataByType(payload.type).name;
            }
            let slug = null;
            if (payload.type === 'home') {
                slug = '/';
            } else {
                slug = context.getters.generateSlug(name);
            }
            let pos = null;
            if ('pos' in payload) {
                payload.pos = pos;
            } else {
                pos = context.getters.getPagesFromMenuId(menu_id).length + 1;
            }
            let newItem = {
                id: pushid(),
                slug: slug,
                name: name,
                title: payload.title || name,
                description: payload.description || null,
                visible: payload.visible || true,
                accessible: payload.accessible || true,
                type: payload.type,
                pos: pos,
                menu_id: menu_id
            };
            await context.dispatch('setProp', {
                source: 'tecpage.user.pages.' + newItem.id,
                value: newItem
            });
            if (payload.with_modules === true) {
                await context.dispatch('createDefaultModulesForPage', {
                    page_id: newItem.id
                });
            }
            return newItem.id;
        }
    }
};
